// extracted by mini-css-extract-plugin
module.exports = {"container":"nav-link_container__2ULU9","image":"nav-link_image__wgoot","label":"nav-link_label__32CU5","active":"nav-link_active__1Z8C_"};